import { render, staticRenderFns } from "./KpiShow.vue?vue&type=template&id=233c1690&scoped=true&"
import script from "./KpiShow.vue?vue&type=script&lang=js&"
export * from "./KpiShow.vue?vue&type=script&lang=js&"
import style0 from "./KpiShow.vue?vue&type=style&index=0&id=233c1690&prod&scoped=true&lang=css&"
import style1 from "./KpiShow.vue?vue&type=style&index=1&id=233c1690&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233c1690",
  null
  
)

export default component.exports